import { createFileRoute } from "@tanstack/react-router";
import { object, number } from "zod";

const searchSchema = object({
  folderId: number().optional(),
});

export const Route = createFileRoute("/sources/projects/$id/dashboards/")({
  staticData: {
    title: "common.dashboards",
  },
  validateSearch: searchSchema,
});
